import { InjectionToken } from '@angular/core';

export const IS_WORKSHEET_DISABLED = new InjectionToken<boolean>('worksheetDisabled');
